module.exports = __webpack_public_path__ + "img/ISO-pic3.669ecbcb.png";